import { apiClient } from "@/shared/services/api";
import type { ApiResponse } from "@/features/auth/services/authApi";

export interface Department {
  id: string;
  code: string;
  name: string;
  description?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export const departmentsApi = {
  getAll: async (): Promise<Department[]> => {
    const { data } = await apiClient.get<ApiResponse<Department[]>>("/Departments");
    return data.data;
  },
};
